import teaserControl from "../../blog/js/teaserControl";

document.addEventListener('DOMContentLoaded', async () => {
    if (document.querySelector('.category')) {
        const category = document.querySelector('h1').textContent.split(' ')[0].toLowerCase();
        teaserControl({fixedCategory: category, category: false, template: 'category', url: '/news'});
    }
})